var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mt-1",
      staticStyle: {
        "min-height": "30vh",
        "flex-direction": "column",
        display: "flex",
        "justify-content": "center",
        "align-items": "center"
      }
    },
    [
      _c("img", {
        attrs: {
          width: _vm.width,
          height: _vm.height,
          src: require("../../assets/img/NoData.svg")
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [_vm._v("暂无数据")]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 red--text" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }